var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('main',{key:_vm.settings.cacheKey,staticClass:"h-100",attrs:{"id":"app"}},[_c('site-header'),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }